module.exports = __webpack_public_path__ + "img/txLogo.c30c4722.png";